import { createContext } from 'react';
import { NotificationsCount } from 'src/common/types';

export const NotificationsCountContext = createContext<NotificationsCount>(0);
